import ShopType from "@/enum/ShopType";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { Button, Modal } from "antd";
import React from "react";

interface NewVirtualPhoneModalProps extends InjectBaseModalProps {
    shopType: ShopType;
}

const NewVirtualPhoneModal: React.FC<NewVirtualPhoneModalProps> = function (props) {
    const { open, onCancel, shopType } = props;

    const tableData = [
        // {
        //     id: 1,
        //     functionPoint: "订单列表手机号展示",
        //     beforeAdjustment: "部分打码，支持一键查看",
        //     afterAdjustment: "保持不变：仍支持单条订单点击查看明文",
        // },
        // {
        //     id: 2,
        //     functionPoint: "多订单批量查看地址",
        //     beforeAdjustment: "支持批量勾选查看明文",
        //     afterAdjustment: "调整为：仅支持单条订单逐一查看明文，取消批量查看",
        // },
        {
            id: 3,
            functionPoint: "订单导出功能",
            beforeAdjustment: "支持导出明文地址订单",
            afterAdjustment: "调整为：导出文件中的姓名、手机号、地址关键信息将自动打码（如：138****1234）",
        },
        // {
        //     id: 4,
        //     functionPoint: "查看单条订单明文",
        //     beforeAdjustment: "无需验证",
        //     afterAdjustment: "调整为：查看单条订单明文手机号需输入图形验证码",
        // },
    ];

    const containerStyle: React.CSSProperties = {
        maxWidth: "1000px",
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "#ffffff",
        fontFamily: "'Microsoft YaHei', 'Segoe UI', Arial, sans-serif",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
        borderRadius: "4px",
    };

    const headerStyle: React.CSSProperties = {
        color: "#333333",
        fontSize: "24px",
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "20px",
        paddingBottom: "15px",
        borderBottom: "2px solid #e8e8e8",
    };

    const descriptionStyle: React.CSSProperties = {
        fontSize: "16px",
        marginBottom: "30px",
        textAlign: "justify",
        lineHeight: "1.6",
        color: "#333333",
    };

    const tableContainerStyle: React.CSSProperties = {
        overflowX: "auto",
        marginTop: "10px",
    };

    const tableStyle: React.CSSProperties = {
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: "0",
    };

    const thStyle: React.CSSProperties = {
        backgroundColor: "#f5f5f5",
        fontWeight: "bold",
        textAlign: "left",
        padding: "16px 12px",
        border: "1px solid #e8e8e8",
        fontSize: "16px",
    };

    const tdStyle: React.CSSProperties = {
        padding: "14px 12px",
        border: "1px solid #e8e8e8",
        fontSize: "14px",
        verticalAlign: "top",
    };

    const trEvenStyle: React.CSSProperties = {
        backgroundColor: "#fafafa",
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            title="重要通知"
            width={970}
            closable={false}
            footer={
                <>
                    <Button type="primary" onClick={onCancel}>
                        关闭
                    </Button>
                </>
            }
        >
            <div style={containerStyle}>
                <div style={headerStyle}>【重要通知】关于{ShopTypeNameMap[shopType]}订单隐私保护功能调整的公告</div>

                <div style={descriptionStyle}>
                    为积极响应国家《个人信息保护法》、《数据安全法》及相关监管要求，进一步加强用户个人信息保护，防止数据泄露风险，发货易将对
                    {ShopTypeNameMap[shopType]}订单的地址信息展示与导出功能进行如下优化调整
                    <span className="danger fb">(本次调整不影响打印、发货)</span>：
                </div>

                <div style={tableContainerStyle}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>功能点</th>
                                <th style={thStyle}>调整前</th>
                                <th style={thStyle}>调整后</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((item, index) => (
                                <tr
                                    key={item.id}
                                    style={index % 2 === 1 ? trEvenStyle : {}}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#f0f7ff";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            index % 2 === 1 ? "#fafafa" : "transparent";
                                    }}
                                >
                                    <td style={tdStyle}>{item.functionPoint}</td>
                                    <td style={tdStyle}>{item.beforeAdjustment}</td>
                                    <td style={tdStyle}>{item.afterAdjustment}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Modal>
    );
};

export default React.memo(NewVirtualPhoneModal);
